import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "icon",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M10.5 1.25C14.5041 1.25 17.75 4.49594 17.75 8.5C17.75 10.9689 16.5148 13.1478 14.6299 14.457L19.0557 22.125L17.7568 22.875L13.3164 15.1826C12.4505 15.548 11.4989 15.75 10.5 15.75C6.49594 15.75 3.25 12.5041 3.25 8.5C3.25 4.49594 6.49594 1.25 10.5 1.25ZM10.5 2.75C7.32436 2.75 4.75 5.32436 4.75 8.5C4.75 11.6756 7.32436 14.25 10.5 14.25C13.6756 14.25 16.25 11.6756 16.25 8.5C16.25 5.32436 13.6756 2.75 10.5 2.75Z",
			fill: "currentColor"
		})
	})
});
export default SvgSearch;
